import React from 'react';
import Leaderboard from '../Leaderboard';

function TeacherDashboard() {
  return (
    <div>
      <Leaderboard />
    </div>
  );
}

export default TeacherDashboard;